<template>
  <div class="pt-0">
<!--    <v-row class="friends-lg">-->
<!--      <v-sheet-->
<!--        class="pt-0"-->
<!--      >-->
<!--        <v-col-->
<!--          cols="12"-->
<!--          class="pt-0 text-center"-->
<!--        >-->
<!--          <v-row class="justify-center font-weight-800 text-h4 text-sm-h3 ma-0 mb-9 mt-9">-->
<!--            <span class="yellow&#45;&#45;text">REFER</span> FRIENDS-->
<!--          </v-row>-->
<!--          <v-row class="justify-center">-->
<!--            <span class="text-h4 font-weight-800 white&#45;&#45;text">Grab all your friends and start earning Maxcoin NOW!</span>-->
<!--          </v-row>-->
<!--          <v-row class="justify-center">-->
<!--            <span class="text-h6 white&#45;&#45;text">Earn 5 Max Coins when you refer your friends to sign up and jump into action! Max Coins are given once both players have made a purchase.-->
<!--            </span>-->
<!--          </v-row>-->
<!--        </v-col>-->
<!--      </v-sheet>-->
<!--    </v-row>-->
<!--    <v-row class="detailbglight">-->
<!--      <v-col-->
<!--        cols="12"-->
<!--        class="pt-0 text-center"-->
<!--      >-->
<!--        <v-row>-->
<!--          <base-card>-->
<!--            <v-card-text>-->
<!--              <v-form-->
<!--                ref="form"-->
<!--                v-model="valid2"-->
<!--                lazy-validation-->
<!--              >-->
<!--                <v-row>-->
<!--                  <v-col-->
<!--                    cols="6"-->
<!--                  >-->
<!--                    <v-text-field-->
<!--                      v-model="email2"-->
<!--                      :rules="emailRules2"-->
<!--                      outlined-->
<!--                      label="E-mail"-->
<!--                      required-->
<!--                    />-->
<!--                  </v-col>-->
<!--                  <v-col-->
<!--                    cols="6"-->
<!--                  >-->
<!--                    <v-text-field-->
<!--                      v-model="email2"-->
<!--                      :rules="emailRules2"-->
<!--                      outlined-->
<!--                      label="E-mail"-->
<!--                      required-->
<!--                    />-->
<!--                  </v-col>-->
<!--                </v-row>-->
<!--                <v-row>-->
<!--                  <v-col-->
<!--                    cols="6"-->
<!--                  >-->
<!--                    <v-text-field-->
<!--                      v-model="email2"-->
<!--                      :rules="emailRules2"-->
<!--                      outlined-->
<!--                      label="E-mail"-->
<!--                      required-->
<!--                    />-->
<!--                  </v-col>-->
<!--                  <v-col-->
<!--                    cols="6"-->
<!--                  >-->
<!--                    <v-text-field-->
<!--                      v-model="email2"-->
<!--                      :rules="emailRules2"-->
<!--                      outlined-->
<!--                      label="E-mail"-->
<!--                      required-->
<!--                    />-->
<!--                  </v-col>-->
<!--                </v-row>-->
<!--                <v-row>-->
<!--                  <v-col-->
<!--                    cols="6"-->
<!--                  >-->
<!--                    <v-text-field-->
<!--                      v-model="email2"-->
<!--                      :rules="emailRules2"-->
<!--                      outlined-->
<!--                      label="E-mail"-->
<!--                      required-->
<!--                    />-->
<!--                  </v-col>-->
<!--                  <v-col-->
<!--                    cols="6"-->
<!--                  >-->
<!--                    <v-text-field-->
<!--                      v-model="email2"-->
<!--                      :rules="emailRules2"-->
<!--                      outlined-->
<!--                      label="E-mail"-->
<!--                      required-->
<!--                    />-->
<!--                  </v-col>-->
<!--                </v-row>-->
<!--                <v-btn-->
<!--                  :disabled="!valid2"-->
<!--                  width="100"-->

<!--                  color="success"-->
<!--                  class="mr-4"-->
<!--                  @click="validate"-->
<!--                >-->
<!--                  Submit-->
<!--                </v-btn>-->

<!--                <v-btn-->
<!--                  color="green"-->
<!--                  width="100"-->
<!--                  class="mr-4"-->
<!--                  @click="reset"-->
<!--                >-->
<!--                  Add More-->
<!--                </v-btn>-->
<!--              </v-form>-->
<!--            </v-card-text>-->
<!--          </base-card>-->
<!--        </v-row>-->
<!--        <v-row>-->
<!--          <v-col-->
<!--            cols="12"-->
<!--            md="4"-->
<!--          >-->
<!--            <v-card>-->
<!--              <v-card-title>-->
<!--                1-->
<!--              </v-card-title>-->
<!--              <v-card-text>-->
<!--                SEND OUT REFERRALS USING THE FORM ABOVE-->
<!--              </v-card-text>-->
<!--            </v-card>-->
<!--          </v-col>-->
<!--          <v-col-->
<!--            cols="12"-->
<!--            md="4"-->
<!--          >-->
<!--            <v-card>-->
<!--              <v-card-title>-->
<!--                2-->
<!--              </v-card-title>-->
<!--              <v-card-text>-->
<!--                GET YOUR REFERRALS TO JOIN MAXQUEST-->
<!--              </v-card-text>-->
<!--            </v-card>-->
<!--          </v-col>-->
<!--          <v-col-->
<!--            cols="12"-->
<!--            md="4"-->
<!--          >-->
<!--            <v-card>-->
<!--              <v-card-title>-->
<!--                3-->
<!--              </v-card-title>-->
<!--              <v-card-text>-->
<!--                GET 5 MAX COINS ON REFERRAL'S FIRST PURCHASE-->
<!--              </v-card-text>-->
<!--            </v-card>-->
<!--          </v-col>-->
<!--        </v-row>-->
<!--        <v-row>-->
<!--          <v-col-->
<!--            cols="12"-->
<!--            md="12"-->
<!--          >-->
<!--            <v-card>-->
<!--              <v-card-text>-->
<!--                See the full Terms & Conditions-->
<!--              </v-card-text>-->
<!--            </v-card>-->
<!--          </v-col>-->
<!--        </v-row>-->
<!--      </v-col>-->
<!--    </v-row>-->
  </div>
</template>
  <script>
  // import analyticOneCard from '@/components/card/AnalyticCardVersionOne'
  // import analyticTwoCard from '@/components/card/AnalyticCardVersionTwo'

  export default {
    name: 'Analytic',
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'Analytic',
    },
    components: {
      // 'analytic-one-card': analyticOneCard,
      // 'analytic-two-card': analyticTwoCard,
    },
    data () {
      return {
        password: '',
        dialogSign: false,
        dialogWelcome: false,
        dialogDaily: false,
        dialogFriends: false,
        email: '',
        show: false,
        slides: 7,
        colors: [
          'indigo',
          'warning',
          'pink darken-2',
          'red lighten-1',
          'deep-purple accent-4',
        ],
        caroitems: [
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg',
          },
          {
            src: '/images/banners/Main_Banner1.png',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
          },
        ],
        slides3d: [
          { title: 'dragonstone', img: '/images/cards/worlds-slider-dragonstone.png', link: '/', body: 'Sign Up Today' },
          { title: 'mission amazon', img: '/images/cards/worlds-slider-missionamazon.png', link: '/' },
          { title: 'mobile warfare', img: '/images/cards/worlds-slider-mobilewarfare.png', link: '/' },
          { title: 'sector x', img: '/images/cards/worlds-slider-sectorx.png', link: '/' },
        ],
      }
    },
    computed: {
    },
  }
  </script>

  <style lang="scss">
  .friends-lg {
    position: relative;
    height: 600px;
    width: 100%;
    background-color: #000000;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }
  .v-carousel__controls {
    background: none !important;
  }
  .v-carousel__controls .v-btn .v-icon {
    margin: 0 8px;
    border-radius: 100px;
    border: 3px solid #F8BF1E;
    background-color: transparent;
    transition: all 400ms ease;
    cursor: pointer;
    color: transparent;
  }
  .v-carousel__controls .v-btn.v-btn--active .v-icon {
    color: #F8BF1E;
  }

  .v-carousel__controls .v-btn--active:hover::before, .v-carousel__controls .v-btn--active::before{
    opacity: 0 !important;
  }
  </style>

  <style lang="scss" scoped>
  .glow-text{
    text-shadow: 0 0 1px #fff, 0 0 1px #fff, 0 0 10px #fff, 0 0 10px #fff, 0 0 120px #fff;
    font-size: 26px !important;
    font-weight: 600 !important;
  }

  .glow-text .text-h2{
    font-size: 55px !important;
    font-weight: 600 !important;
  }

  .max-coins-img {
    width: 500px;
    max-width: 95%;
    margin: auto;
  }

  .referfriends_text_card {
    color: white;
    position: relative;
    font-size: 62px;
    text-align: center;
    top: 40%;
    left: 50%;
    font-weight: 900;
    transform: translate(-50%, -50%);
  }
  .carousel-3d-container figure {
    margin:0;
  }
  .carousel-3d-container {
    .carousel-3d-slide {
      background-color: rgba(0, 0, 0, 0.5);
      margin: 10px;
    }
  }
  .carousel-3d-container figcaption {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    bottom: 0;
    position: absolute;
    bottom: 0;
    padding: 15px;
    font-size: 12px;
    min-width: 100%;
    box-sizing: border-box;
  }
  .pvp-lg {
    position: relative;
    height: 600px;
    width: 100%;
    background-image: url('/images/banners/Background_BannerPVP.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }
  .detailbg {
    position: relative;
    background-image: url('/images/backgrounds/dark-purple-bg-min.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }
  .pvp_text {
    left:0px;
    top: 130px;
    text-shadow: 1px 1px 1px #000000;
    text-align: center;
    font-style: normal;
    font-weight: 900;
    font-size: 32px;
    line-height: 110%;
    color:#ffffff;
  }
  .rewards_text {
    left:0px;
    top: 130px;
    text-shadow: 1px 1px 1px #000000;
    text-align: center;
    font-style: normal;
    font-weight: 900;
    font-size: 32px;
    line-height: 110%;
    color:#ffffff;
  }
  .detailbglight {
    position: relative;
    background-image: url('/images/backgrounds/light-purple-bg-min.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }
  .signup-text {
    margin-top: 0.725rem;
    font-size: 12px;
  }

  .social-icon-login {
    margin-left: 0.7rem;
  }

  .c-checkbox {
    color: #292f36 !important;
    margin-top: 0.725rem;
  }

  .login-btn-new {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 700;
    font-size: 19px;
    line-height: 125%;
    color: #292f36 !important;
    background: #F8BF1E !important;
  }
  .title-text {
    // font-family: 'Roboto';
    // font-style: normal;
    // font-weight: 400;
    // font-size: 24px;
    // line-height: 32px;
    // color: #424242;
    font-family: "Sora";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: #292f36;
  }
  .light-grey {
    background-color: #fafafa;
  }

  // .v-sheet.v-card {
  //   border-top: 4px solid #00A1B7 !important;
  // }
  </style>
